import { Link } from "react-router";

import type { DramaWatchHistoryItem } from "~/api/drama";

export function ContinueCard({ item }: { item: DramaWatchHistoryItem }) {
  const { series, episodeNumber, watchProgress = 0 } = item;
  const query = new URLSearchParams({ series: series.id });
  if (episodeNumber) query.set("ep", String(episodeNumber));

  return (
    <Link
      id={`cinema-continue-card-${series.id}`}
      to={`/cinema/watch?${query}`}
      className="flex w-[124px] shrink-0 flex-col gap-[8px] md:w-[213px]"
    >
      <div className="aspect-[2/3] w-full overflow-hidden rounded-[12px] border border-white/10 bg-neutral-800">
        {series.thumbnail && <img src={series.thumbnail} alt="" loading="lazy" className="size-full object-cover" />}
      </div>
      {/* The native element, so the watched fraction needs no inline width. */}
      <progress
        value={watchProgress}
        max={1}
        aria-label="Watched"
        className="[&::-webkit-progress-value]:bg-brand-500 [&::-moz-progress-bar]:bg-brand-500 h-[4px] w-full appearance-none overflow-hidden rounded-[2px] bg-white/16 [&::-webkit-progress-bar]:bg-white/16"
      />
      <div>
        <p className="line-clamp-2 text-[14px] leading-[20px] font-semibold text-neutral-50">{series.title}</p>
        {episodeNumber && (
          <p className="text-[10px] leading-[14px] font-medium text-neutral-500">
            EP.{episodeNumber}
            {series.episodeCount ? ` / ${series.episodeCount}` : ""}
          </p>
        )}
      </div>
    </Link>
  );
}
